import ToppingPlacement from './ToppingPlacement';

export default ToppingPlacement;
